export interface IFileHeader {
  id: string
  clientName: string
  fileType: string
  fileHeaderName: string
  mappedColumnName: string | null
  sampleData: string | null
  borrowingBaseId: string | null
}

export interface IFileHeaderData {
  data: IFileHeader[]
}

export enum FileType {
  //TODO: Add other file types
  LEGAL_DOCUMENT = 'legal',
}

export enum FileErrorType {
  PARSING_ERROR = 'parsing_error',
  FORMAT_ERROR = 'format_error',
  UPLOAD_ERROR = 'upload_error',
  API_ERROR = 'api_error',
  PERMISSION_ERROR = 'permission_error',
  VALIDATION_ERROR = 'validation_error',
  UNKNOWN_ERROR = 'unknown_error',
}

export enum ProcessingModule {
  ONGOING_REPORTING = 'ongoing_reporting',
  OPS_REPORTING = 'ops_reporting',
  DD_REPORTING = 'dd_reporting',
  BBC = 'bbc',
}

export enum Status {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export enum FileProcessingStatus {
  IDLE = 'idle',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

/** Statuses a file cannot move out of on its own — a failure is as final as a success. */
export const TERMINAL_FILE_STATUSES = [FileProcessingStatus.COMPLETED, FileProcessingStatus.FAILED]
